import { useContext } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { UserContext } from '@namespace/user';

export const useSupportMail = () => {
  const [user] = useContext(UserContext);
  const { id } = user;

  const { payments = {} } = useOtherSettings();
  const {
    supportServiceEmail = 'support@favbet.ua',
    supportServiceEmailSubject = 'Підтвердження платіжного засобу (Акаунт №'
  } = payments;

  const supportMailWithSubject = `${supportServiceEmail}?subject=${supportServiceEmailSubject}${id})`;

  return supportMailWithSubject;
};
